import { Form, Select } from 'antd';
import type { FormInstance } from 'antd/es/form';
import {
  labelFormats,
  labelSizeOptions,
  labelSizes,
  pageSizeOptions,
  pageSizes,
} from '@page-components/warehouse/common';
import { PalletLabelFormatSelector } from './PalletLabelFormatPreview';

export type LabelFormValues = {
  labelSize: (typeof labelSizes)[keyof typeof labelSizes];
  pageSize: (typeof pageSizes)[keyof typeof pageSizes];
  labelFormat: (typeof labelFormats)[keyof typeof labelFormats];
};

export const DEFAULT_LABEL_FORM_VALUES: LabelFormValues = {
  labelSize: labelSizes.TwoByFour,
  pageSize: pageSizes.Letter,
  labelFormat: labelFormats.Detailed,
};

const labelSizeSelectOptions = labelSizeOptions.map(option => ({
  label: option.text,
  value: option.value,
}));

const pageSizeSelectOptions = pageSizeOptions.map(option => ({
  label: option.text,
  value: option.value,
}));

type InboundPalletLabelOptionsFormProps = {
  form: FormInstance<LabelFormValues>;
};

export function InboundPalletLabelOptionsForm({
  form,
}: InboundPalletLabelOptionsFormProps) {
  return (
    <Form form={form} layout="vertical" initialValues={DEFAULT_LABEL_FORM_VALUES}>
      <Form.Item
        name="labelSize"
        label="Label size"
        rules={[{ required: true, message: 'Select a label size' }]}
      >
        <Select
          placeholder="Select label size"
          options={labelSizeSelectOptions}
          style={{ width: '100%' }}
        />
      </Form.Item>
      <Form.Item
        name="pageSize"
        label="Page size"
        rules={[{ required: true, message: 'Select a page size' }]}
      >
        <Select
          placeholder="Select page size"
          options={pageSizeSelectOptions}
          style={{ width: '100%' }}
        />
      </Form.Item>
      <Form.Item
        name="labelFormat"
        label="Label format"
        rules={[{ required: true, message: 'Select a label format' }]}
      >
        <PalletLabelFormatSelector />
      </Form.Item>
    </Form>
  );
}
